// extracted by mini-css-extract-plugin
var _1 = "InhabitantFormInvitationActions-modulecheckbox__yWqck";
var _2 = "InhabitantFormInvitationActions-modulecheckboxField__RT3F0";
var _3 = "InhabitantFormInvitationActions-moduleviewButton__DJlJp";
export { _1 as "checkbox", _2 as "checkboxField", _3 as "viewButton" }
